import { css } from 'styled-components/macro'

// Styles for the Setting rows: the white cards, their explainer strips, stacked groups and toggles.
// Interpolated by every modal that renders Setting components.
export const settingStyles = css`
  .left-side {
    display: flex;
    align-items: center;
    flex: 1;
  }

  .setting {
    display: inline-flex;
    flex-direction: row;
    justify-content: space-between;
    padding: 16px;
    border-radius: 16px;
    box-shadow: 0 0px 12px ${props => props.theme.mutedText}44;
    box-sizing: border-box;
    position: relative;
    overflow: hidden;
    border: 1px solid ${props => props.theme.white};
    transition: all 0.2s cubic-bezier(0.25, 1, 0.32, 1);
    background: ${props => props.theme.white};
    box-shadow: none;
    /* padding: 16px 8px; */
    border: 1px solid ${props => props.theme.border};
    width: 100%;
    position: relative;
    margin-top: 16px;
    min-height: 66px;

    .day-pills {
      align-items: flex-start;
      justify-content: flex-start;
      gap: 8px;
      margin: 16px 0;
      min-height: auto;
    }

    input {
      padding-right: 12px;
      width: calc(100% - 12px);
      background-color: ${props => props.theme.white};
    }

    input,
    textarea {
      background-color: ${props => props.theme.white};
    }

    .setting-icon {
      width: 30px;
      height: 30px;
      display: inline-flex;
      justify-content: center;
      align-items: center;
      margin-right: 12px;
      margin-left: 0px;
      font-size: 13px;
      color: #fff;

      img {
        width: 100%;
        object-fit: contain;
      }
    }

    .invalid-url {
      color: ${props => props.theme.red};
      font-size: 14px;
      font-weight: 500;
      margin-top: 4px;
    }

    .bullet {
      margin-left: 8px;
      margin-top: 2px;
      flex-shrink: 0;
    }

    .setting-name {
      font-weight: 500;
      position: relative;
      z-index: 2;
      display: flex;
      align-items: center;
    }

    &:has(.setting-header) {
      flex-direction: column;
      align-items: stretch;
    }

    .setting-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      width: 100%;
    }

    .setting-body {
      width: 100%;
      margin-top: 16px;

      input,
      textarea {
        width: 100%;
        padding: 12px;
        border-radius: 8px;
        border: 1px solid ${props => props.theme.border};
        margin-top: 0;
      }

      textarea {
        min-height: 120px;
        resize: vertical;
      }

      .setting-label {
        font-size: 14px;
        font-weight: 500;
        color: ${props => props.theme.mutedText};
        margin-bottom: 8px;
      }

      .info-content {
        .info-row {
          margin-bottom: 8px;
          font-size: 14px;
          line-height: 1.5;
        }
      }
    }
  }

  .settings-group {
    .setting {
      border-radius: 0;
      border-top-width: 0;
      margin-top: 0;

      &:first-of-type {
        border-top-right-radius: 16px;
        border-top-left-radius: 16px;
        border-top-width: 1px;
        margin-top: 16px;
      }

      &:last-of-type,
      &:has(+ .setting-explainer) {
        border-bottom-right-radius: 16px;
        border-bottom-left-radius: 16px;
      }
    }

    /* Zebra striping only reads as such from three rows up; a "plain" group never stripes */
    &:not(.plain):has(.setting ~ .setting ~ .setting) .setting:nth-of-type(even) {
      background-color: ${props => props.theme.activeBackground};

      input,
      textarea {
        background-color: ${props => props.theme.white};
      }
    }
  }

  .setting-question {
    margin-top: 40px;
    margin-bottom: 0;
    font-size: 18px;
    text-align: center;
    max-width: 420px;
    align-self: center;
    justify-self: center;

    &.nomargin {
      margin-top: 0;
    }

    @media (max-width: 768px) {
      font-size: 18px;
    }
  }

  .setting-explainer {
    background: ${props => props.theme.blue}22;
    border-radius: 0 0 24px 24px;
    padding: 32px 16px 10px;
    text-align: center;
    margin-top: -24px;
    margin-bottom: 24px;
    width: calc(100% - 32px);
    margin-left: 16px;
    font-size: 15px;
    gap: 4px;

    svg {
      color: ${props => props.theme.accent};
      margin-right: 1px;
    }

    &.warning {
      font-weight: 500;
      background: ${props => props.theme.lightOrange};
      color: ${props => props.theme.redOrange};

      svg {
        color: ${props => props.theme.redOrange};
      }
    }

    &.error {
      font-weight: 500;
      background: ${props => props.theme.lightRed};
      color: ${props => props.theme.red};

      svg {
        color: ${props => props.theme.red};
      }
    }
  }

  .right-side {
    display: flex;
    align-items: center;

    .toggle {
      margin-left: 8px;

      &.react-toggle .react-toggle-thumb {
        height: 28px;
        width: 28px;
      }

      &.react-toggle--focus .react-toggle-thumb {
        box-shadow: none !important;
      }

      &.react-toggle:hover:not(.react-toggle--disabled) .react-toggle-track {
        background-color: ${props => props.theme.mutedText}44;
      }

      &.react-toggle .react-toggle-track {
        height: 30px;
        width: 56px;
        background-color: ${props => props.theme.mutedText}88;
      }

      &.react-toggle:not(.react-toggle--checked) .react-toggle-thumb {
        border-color: ${props => props.theme.mutedText}88;
      }

      &.react-toggle--checked .react-toggle-thumb {
        border-color: ${props => props.theme.accent};
      }

      &.react-toggle--checked .react-toggle-track {
        background-color: ${props => props.theme.accent};
      }

      &.react-toggle--checked:hover:not(.react-toggle--disabled) .react-toggle-track {
        background-color: ${props => props.theme.accent}bb;
      }
    }
  }
`
